<div class="main-dialog" *ngIf="data.status == 'send' || data.status == 'yes' || data.status ==  'no'">
  <div class="m-4">
    <div class="row text-center" >
      <ng-container *ngIf="data.status == 'send'">
        <div class="btn-algn">
          <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Tick.svg" alt="" />
        </div>
        <div class="col-xl-12 mt-3">
          <span>{{ data.message.message | translate }}</span>
          <p class="color-purple">{{ data.message.emailid}}</p>
        </div>
      </ng-container>
      <ng-container *ngIf="data.status == 'yes' ||data.status ==  'no' && data.status != 'send'">
        <div class="row col-12 justify-content-center  pl-4 px-0">
          <div class="px-0 finaldecision pt-3" [ngClass]="data.status == 'yes'?'col-6 pb-3':'col-10 pb-2' ">
            <span>{{ data.message | translate }}</span>
          </div>
        </div>
      </ng-container>
      <div class="col-xl-12 mt-3">
        <dxc-button class="btn-search btn" mode="primary" label="{{ 'label.common.okay' | translate }}" margin="xxsmall"
          (click)="onClose()"></dxc-button>
      </div>
    </div>
  </div>
</div>
<div class="bg-color" [ngStyle]="detail.colorBG" *ngIf="data.status == 'success'">
  <label> {{ "label.common.popup." + detail.message | translate }}</label>
</div>
<div class="bg-color" [ngStyle]="detail.colorBG" *ngIf="data.status == 'successmessage'">
  <label> {{ detail.message | translate }}</label>
</div>

<div class="bg-color" [ngStyle]="detail.colorBG" *ngIf="data.status == 'error'">
  <label> {{ detail.message | translate }}</label>
</div>
<!-- Show Error and reason -->
<div class="bg-color flex-column " [ngStyle]="detail.colorBG" *ngIf="data.status == 'errorAndReason'">
  <label> {{ detail.message | translate }}</label>
  <label> {{ detail.reasonError | translate }}</label>
</div>

<div *ngIf="data.status == 'Information'">
  <div id="dialogHeader" class="text-center mt-3">
    <img src="{{ data.icon }}" alt="" />
  </div>

  <div class="m-4">
    <div class="row text-center">
      <div class="col-12">
        <span>{{ data.message | translate }}</span>
      </div>
      <div class="col-12 mt-3">
        <dxc-button class="btn-search btn" mode="primary" label="{{ 'label.common.okay' | translate }}" margin="xxsmall"
          (click)="onClose()"></dxc-button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="data.status == 'Error'">
  <div id="dialogHeader" class="text-center p-0" [ngStyle]="data.colorBG">
    <label class="error-label">Error</label>
  </div>

  <div class="m-4">
    <div class="row text-center">
      <div class="col-12">
        <span *ngIf="data.message.response.data">{{
          "label.common.mandatory" | translate
          }}</span>
        <span *ngIf="data.message.response.data.error">{{
          data.message.response.data.error
          }}</span>
        <span *ngIf="data.message.response.data.message">{{
          data.message.response.data.message
          }}</span>

        <span *ngIf="!data"> searching for local connection</span>
      </div>
      <div class="col-12 mt-3">
        <dxc-button class="btn-search btn" mode="primary" label="{{ 'label.common.okay' | translate }}" margin="xxsmall"
          (click)="onClose()"></dxc-button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="data.status == 'alreadyError'">
  <div id="dialogHeader" class="text-center p-0" [ngStyle]="data.colorBG">
    <label class="error-label">Error</label>
  </div>

  <div class="m-4">
    <div class="row text-center">
      <div class="col-12">
        <span>{{ data.message }}</span>
      </div>
      <div class="col-12 mt-3">
        <dxc-button class="btn-search btn" mode="primary" label="{{ 'label.common.okay' | translate }}" margin="xxsmall"
          (click)="onClose()"></dxc-button>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="data.status == 'channelProduct'">
  <div class="dialog-content">
    <h5 class="text-center m-4">{{ data.message.title }}</h5>
    <div class="row text-center">
      <div class="col-md-12 dialog-detail">
        <custom-input-text label="{{ 'label.common.marketingName' | translate }}">
        </custom-input-text>
      </div>
    </div>
    <div class="custome-btn mb-3 mt-2">
      <dxc-button mode="primary" label="{{ 'label.common.save' | translate }}" margin="xxsmall" (click)="btnSave()">
      </dxc-button>
      <dxc-button class="btn-only" mode="text" label="{{ 'label.common.cancel' | translate }}" margin="xxsmall"
        (click)="onClose()">
      </dxc-button>
    </div>
  </div>
</ng-container>